export default "__VITE_ASSET__DWGbvLk0__"